<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> </template>

		<div class="container-fluid" style="text-align: left;">
			<div class="row mt-3">
				<div class="col-sm-3">
					<admin-nav></admin-nav>
				</div>

				<div class="col-sm-9">
					<div class="d-flex flex-row align-items-start">
						<div class="row flex mr-3">
							<div class="col-12 col-lg-4 mb-2 d-flex flex-row align-items-center">
								<i v-if="!filter" style="min-width: 15px;" class="fas fa-search mx-2" />
								<i
									v-if="filter"
									style="min-width: 15px; padding-left: 2px; padding-top: 2px;"
									class="fas fa-times mx-2 clickable"
									@click="filter = ''"
								/>
								<input
									class="form-control listing-search"
									placeholder="Search classes..."
									v-model="filter"
								/>
							</div>
							<div class="col-12 col-lg-8 mb-2">
								<config-select
									:options="districts"
									:nullOption="true"
									byField="id"
									v-model="district_id"
								/>
							</div>
						</div>
						<button @click="exportItems" class="btn btn-primary mr-3" v-tippy title="Export">
							<i class="fas fa-file-export" />
						</button>
						<a href="/#/sections/new" class="btn btn-primary mr-3">New</a>
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
							style="float: right;"
						></b-pagination>
					</div>
					<b-table
						ref="table"
						:show-empty="true"
						:items="items"
						:fields="fields"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
					>
						<template v-slot:cell(district)="data">
							<div v-if="!data.item.district_id" class="text-very-muted">None</div>
							<div v-else>{{ getDistrictName(data.item.district_id) }}</div>
						</template>
						<template v-slot:cell(actions)="data">
							<div class="d-flex flex-row align-items-center">
								<a :href="`/#/sections/${data.item.id}`" class="mr-1 btn btn-inline btn-success"
									>Edit</a
								>
								<confirm-delete
									typeName="Class"
									:objectName="data.item.name"
									:objectId="data.item.id"
									:canDelete="service.canDeleteSection"
									:delete="service.deleteSection"
									:cleanup="$refs.table.refresh"
								>
									<button class="btn btn-inline btn-danger">Delete</button>
									<template v-slot:cantDeleteMessage>
										<h3>
											The Class
											<span class="text-danger _600">"{{ data.item.name }}"</span>
											cannot be deleted
										</h3>
										<div class="mt-3 text-md text-muted">
											To preserve data integrity, classes that have defined teams or assignments
											are no longer deleteable
										</div>
									</template>
								</confirm-delete>
							</div>
						</template>
					</b-table>
				</div>
			</div>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AdminNav from "@/vues/admin/AdminNav";
import ConfirmDelete from "@/components/ConfirmDelete";
import ConfigSelect from "@/components/ConfigSelect"
import AdminService from "@/services/AdminService";
import FileService from "@/services/FileService";
import Notie from "@/services/NotieService";
import Store from "@/services/Store";
import _ from "lodash";

export default {
	name: "SectionListing",

	props: ["user"],

	components: { MainPage, AdminNav, ConfirmDelete, ConfigSelect },

	data() {
		return {
			service: AdminService,
			districts: null,

			filter: Store.get(this, "SectionListing.filter"),
			currentPage: 1,
			perPage: 25,
			sortBy: "",
			sortDesc: false,
			totalRows: 1,

			district_id: Store.get(this, "SectionListing.district_id"),

			fields: [
				{ key: "name", label: "Name", sortable: true },
				{ key: "district", label: "District" },

				{ key: "actions", label: "Actions" },
			],
		};
	},

	watch: {
		filter() {
			Store.set(this, "SectionListing.filter", this.filter);
		},
		
		district_id() {
			Store.set(this, "SectionListing.district_id", this.district_id);
			this.$refs.table.refresh();
		}
	},

	created() {
		this.loadConfig();
	},

	methods: {
		loadConfig() {
			this.service
				.listDistricts({})
				.then((r) => {
					this.districts = r.data.result;
				})
				.catch((e) => {
					console.error(e);
					Notie.error("Failed to load districts", e);
				});
		},

		items() {
			var pageOpts = {
				filter: this.filter,
				query: {"is_contest": false},
				page_size: this.perPage,
				current_page: this.currentPage,
				sort_by: this.sortBy,
				sort_desc: this.sortDesc,
				skip: (this.currentPage - 1) * this.perPage,
			};

			if (this.district_id) {
				pageOpts.query["district_id"] = this.district_id;
			}

			let timestamp = new Date().getTime();
			this.latest = timestamp;
			return new Promise((resolve, reject) => {
				this.service
					.listSections(pageOpts)
					.then((resp) => {
						if (timestamp != this.latest) {
							return;
						}

						console.log(resp);
						resolve(resp.data.result);
						this.totalRows = resp.data.count;
					})
					.catch((e) => {
						reject(e);
					});
			});
		},

		exportItems() {
			var pageOpts = {
				filter: this.filter,
				query: {"is_contest": false},
				page_size: 0,
				current_page: 0,
				sort_by: this.sortBy,
				sort_desc: this.sortDesc,
				skip: 0,
			};

			if (this.district_id) {
				pageOpts.query["district_id"] = this.district_id;
			}

			this.service
				.listSections(pageOpts)
				.then((r) => {
					console.log("ALL ITEMS", r.data.result);
					FileService.exportSections(r.data.result, this.districts);
				})
				.catch((e) => {
					console.error(e);
					Notie.error("Failed to export classes", e);
				});
		},

		getDistrictName(id) {
			let district = _.find(this.districts, { id: id });
			if (!district) {
				return "(Unknown)";
			}

			return district.name;
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
